<template>
  <div class="site-title">
    <a href="/" title="PG&E Your Projects" aria-label="PG&E Your Projects">
      <SiteLogo />
    </a>
    <h1 class="text-brand">Your Projects</h1>
  </div>
</template>

<script setup>
import SiteLogo from './SiteLogo.vue'
</script>
